// EmployeeListAttendance.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faUserPen,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
const EmployeeListAttendanceReport = () => {
  const [employees, setEmployees] = useState([]);
  const [kithendata, setkithendata] = useState([]);
  const [initialEmployees, setInitialEmployees] = useState([]);
  const [searchField, setSearchField] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportFormat, setReportFormat] = useState("normal"); // 'normal' or 'pa'

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const calculateSpentTime = (entry, exit) => {
    const entryDate = new Date(entry);
    const exitDate = new Date(exit);

    const diffMs = exitDate - entryDate;
    if (isNaN(diffMs) || diffMs < 0) return "-";

    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${diffHours}h ${diffMinutes}m`;
  };
  console.log(searchField, "dsfjsdkl");
  const formatDisplayDate = (date) => {
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };
  const [currentDate, setCurrentDate] = useState(new Date());
  // Format date to "YYYY-MM-DD" for API
  const formatAPIDate = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const navigate = useNavigate();
  const formatDateTimeWithAmPm = (utcString) => {
    const date = new Date(utcString);
    const options = {
      timeZone: "Asia/Kolkata",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      // day: "2-digit",
      // month: "2-digit",
      // year: "numeric",
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date); // "25-06-2025, 10:30 AM"
  };
  useEffect(() => {
    const formattedDate = formatAPIDate(currentDate);
    const params = {
      serchdate: formattedDate,
      // id:searchField,
    };
    axios
      .get(
        `https://ims-attendanceback.indevconsultancy.in/api/attendance-detail-master/`,
        { params }
      )
      .then((response) => {
        console.log(response.data);
        if (response.data) {
          setEmployees(response.data);
          setInitialEmployees(response.data.employees);
        }
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
      });
  }, [currentDate]);
  useEffect(() => {
    axios
      .get(`https://ims-attendanceback.indevconsultancy.in/api/kitchen-master/`)
      .then((response) => {
        if (response.data) {
          setkithendata(response.data);
          console.log(kithendata);
        }
      });
  }, []);
  useEffect(() => {
    fetchAttendance();
  }, [month]);

  const fetchAttendance = async () => {
    // TODO: Replace this with actual API
    // Demo data for example
    const sampleData = [
      { id: 1, emp_name: "John Doe", status: "present", date: "2025-06-10" },
      { id: 2, emp_name: "Jane Smith", status: "absent", date: "2025-06-12" },
      { id: 1, emp_name: "John Doe", status: "present", date: "2025-06-15" },
    ];
    const filtered = sampleData.filter((d) => d.date.startsWith(month));
    setAttendanceData(filtered);
  };

  const handleEdit = (id) => {
    alert(`Edit employee with ID: ${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this employee?")) {
      const updated = employees.filter((emp) => emp.id !== id);
      setEmployees(updated);
      setInitialEmployees(updated);
    }
  };

  const exportToCSV = (data, filename = "data.csv") => {
    const csvRows = [];

    // Get headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(","));

    // Loop over rows
    for (const row of data) {
      const values = headers.map((header) => {
        const escaped = ("" + row[header]).replace(/"/g, '\\"');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(","));
    }

    // Create blob and download
    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
const handleDownloadWithFilter = async () => {
  if (!fromDate || !toDate) {
    alert("Please select both From and To dates!");
    return;
  }

  try {
    setIsDownloading(true);

    // Build params dynamically
    const params = {
      from_date: fromDate,
      to_date: toDate,
      report_format: reportFormat, // 'normal' (times) OR 'pa' (P/A status codes)
      // NOTE: don't rename to 'format' — that's reserved by DRF for content negotiation (causes 404)
    };

    if (searchField) {
      params.kitchen_id = searchField; // ✅ only set if not null/empty
    }

    const response = await axios.get(
      "https://ims-attendanceback.indevconsultancy.in/api/createexcelreport",
      {
        params,
        responseType: "blob",
      }
    );

    console.log("Request params:", params);

    // Download file
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    const fmtSuffix = reportFormat === "pa" ? "_PA" : "";
    link.setAttribute("download", `report_${fromDate}_to_${toDate}${fmtSuffix}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setShowModal(false); // close modal after download
  } catch (err) {
    console.error("Error downloading Excel file:", err);
  } finally {
    setIsDownloading(false);
  }
};


  

  const convertToIndianTime = (utcString) => {
    const date = new Date(utcString);
    const options = {
      timeZone: "Asia/Kolkata",
      hour12: false,
    };
    const indianTime = date.toLocaleString("en-GB", options);
    const [ddmmYYYY, time] = indianTime.split(", ");
    const [dd, mm, yyyy] = ddmmYYYY.split("/");
    return `${yyyy}-${mm}-${dd} ${time}`;
  };
  const handleSearch = () => {
    const formattedDate = formatAPIDate(currentDate);
    const params = {
      serchdate: formattedDate,
      id: searchField,
    };
    axios
      .get(
        `https://ims-attendanceback.indevconsultancy.in/api/attendance-detail-master/`,
        { params }
      )
      .then((response) => {
        console.log(response.data);
        if (response.data) {
          setEmployees(response.data);
          setInitialEmployees(response.data.employees);
        }
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
      });
  };
  const handleReset = () => {
    navigate("/final-attendance-report-emp");
  };

  const exportToExcel = () => {
    const data = employees.map((emp) => {
      const statusForMonth = attendanceData.filter(
        (a) => a.emp_name === emp.emp_name
      );
      const presentDays = statusForMonth.filter(
        (a) => a.status === "present"
      ).length;
      const absentDays = statusForMonth.filter(
        (a) => a.status === "absent"
      ).length;

      return {
        Name: emp.emp_name,
        Mobile: emp.emp_mobile_no,
        Month: month,
        "Present Days": presentDays,
        "Absent Days": absentDays,
      };
    });
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
    XLSX.writeFile(workbook, `Attendance_Report_${month}.xlsx`);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employees.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(employees.length / itemsPerPage);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    const dateParam = formatAPIDate(currentDate);
    //fetchData(dateParam);
  }, [currentDate]);

  const goToPreviousDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };

  const goToNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };

  return (
    <div className="px-3 py-3 bg-cream" style={{ minHeight: "100%" }}>
      <div className="card">
        <div className="card-header bg-skyBlue text-white">
          <h5 className="mb-0">Employee List</h5>
        </div>
        <div className="card-body">
          <div className="row g-2 g-md-3 align-items-center mb-3">
            <div className="col-12 col-md-3">
              <select
                className="form-select"
                value={searchField}
                onChange={(e) => setSearchField(e.target.value)}
              >
                <option value="">Select Kithen</option>
                {kithendata.map((row) => (
                  <option key={row.kitchenid} value={row.kitchenid}>
                    {row.kitchen_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-primary w-100" onClick={handleSearch}>
                Search
              </button>
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-secondary w-100" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3">
            {/* Total Employees */}
            <h6 className="mb-0">
              Total Employees: <strong>{employees.length}</strong>
            </h6>

            {/* Date Navigator */}
            <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
              <button onClick={goToPreviousDay} className="badge bg-secondary">
                Previous
              </button>

              <h6 className="mb-0 text-nowrap">
                Date: {formatDisplayDate(currentDate)}
              </h6>

              <button onClick={goToNextDay} className="badge bg-secondary">
                Next
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center">
              <thead className="table-light">
                <tr>
                  <th>Employee Code</th>
                  <th>Employee Name</th>
                  <th>Kitchen Name</th>
                  {/* <th>Date</th> */}
                  <th>Entry Time</th>
                  <th>Exit Time</th>
                  <th>Entry Image</th>
                  <th>Exit Image</th>
                  <th>Time Spend</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="9">No employees found.</td>
                  </tr>
                ) : (
                  currentItems.map((emp, index) => {
                    const statusForEmployee = attendanceData.filter(
                      (a) => a.emp_name === emp.emp_name
                    );
                    const presentDays = statusForEmployee.filter(
                      (a) => a.status === "present"
                    ).length;
                    const absentDays = statusForEmployee.filter(
                      (a) => a.status === "absent"
                    ).length;

                    return (
                      <tr key={emp.id}>
                        <td>{emp.emp_code || "-"}</td>
                        <td>{emp.emp_name}</td>
                        <td>{emp.kitchen_name}</td>
                        {/* <td>{emp.created_at ? new Date(emp.created_at).toISOString().slice(0, 10) : "-"}</td> */}
                        <td>
                          {emp.entry_time
                            ? formatDateTimeWithAmPm(emp.entry_time)
                            : "-"}
                        </td>
                        <td>
                          {emp.exit_time
                            ? formatDateTimeWithAmPm(emp.exit_time)
                            : "-"}
                        </td>
                        <td>
                          <img
                            src={emp.entryimage}
                            alt=""
                            srcset=""
                            height="40px"
                            width="60px"
                          />
                        </td>
                        <td>
                          <img
                            src={emp.exitimage}
                            alt=""
                            srcset=""
                            height="40px"
                            width="60px"
                          />
                        </td>
                        <td>
                          {emp.entry_time && emp.exit_time
                            ? calculateSpentTime(emp.entry_time, emp.exit_time)
                            : "-"}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            <nav
              className="mt-3 d-flex justify-content-between"
              aria-label="Pagination"
            >
              <div>
                <button
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => exportToCSV(employees, "employees.csv")}
                >
                  Export CSV
                </button>
                <button
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowModal(true)}
                >
                  Download Report
                </button>
              </div>
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>

                {/* Show up to 3 page numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter((page) => {
                    return (
                      page === 1 || // Always show first page
                      page === totalPages || // Always show last page
                      (page >= currentPage - 1 && page <= currentPage + 1) // Show range around current
                    );
                  })
                  .map((page, i, filteredPages) => {
                    // Add ellipsis if gap between current and previous page is more than 1
                    const prevPage = filteredPages[i - 1];
                    const showEllipsis = prevPage && page - prevPage > 1;

                    return (
                      <React.Fragment key={page}>
                        {showEllipsis && (
                          <li className="page-item disabled">
                            <span className="page-link">…</span>
                          </li>
                        )}
                        <li
                          className={`page-item ${
                            currentPage === page ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => changePage(page)}
                          >
                            {page}
                          </button>
                        </li>
                      </React.Fragment>
                    );
                  })}

                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="card-footer text-muted text-center small">
          Technology Partner: Indev Consultancy ©2025
        </div>
      </div>

      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Filter Report</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                 <div className="mb-3">
                  <label>Select Kitchen</label>
                  <select
                    className="form-select"
                    value={searchField}
                    onChange={(e) => setSearchField(e.target.value)}
                  >
                    <option value="">Select Kitchen</option>
                    {kithendata.map((row) => (
                      <option key={row.kitchenid} value={row.kitchenid}>
                        {row.kitchen_name} 
                      </option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label>From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label>To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="d-block mb-1">Report Format</label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="reportFormat"
                      id="fmtNormal"
                      value="normal"
                      checked={reportFormat === "normal"}
                      onChange={(e) => setReportFormat(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="fmtNormal">
                      Normal Report (In/Out Times)
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="reportFormat"
                      id="fmtPA"
                      value="pa"
                      checked={reportFormat === "pa"}
                      onChange={(e) => setReportFormat(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="fmtPA">
                      P/A Format (Present/Absent codes)
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                  disabled={isDownloading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={handleDownloadWithFilter}
                  disabled={isDownloading}
                >
                  {isDownloading && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  {isDownloading ? "Downloading..." : "Download"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeListAttendanceReport;
